import images from './images';

const food = [
  {
    title: 'モーニング',
    price: '500円',
  },
  {
    title: '本日のランチ',
    price: '550〜700円',
  },
  {
    title: '山の幸セット(いのしし焼肉・ご飯・小鉢・味噌汁)',
    price: '1500円〜',
  },
  {
    title: 'ハンバーグセット(ハンバーグ・サラダ・小鉢・ごはん・味噌汁)',
    price: '1000円〜',
  },
  {
    title: 'とろとろたまごのオムライス(サラダ付)',
    price: '1000円',
  },
  {
    title: 'オムプレート',
    price: '1300円',
  },
  {
    title: '特盛りフライセット',
    price: '1450円',
  },
  {
    title: 'カレーセット',
    price: '900円〜',
  },
  {
    title: 'あつあつグラタン',
    price: '950円',
  },
  {
    title: '鉄板ナポリタン',
    price: '950円',
  },
  {
    title: 'ホットサンド',
    price: '520円',
  },
  {
    title: 'ピザ',
    price: '1000円',
  },



];

const drinks = [
  {
    title: 'コーヒー',
    price: '400円',
  },
  {
    title: '紅茶',
    price: '400円',
  },

];



export default { food, drinks };
